<div class="component-wrapper">
  @if (label !== '') {
    <div id="label" [class.noTopPadding]="noTopPaddingForLabel">
      @if (hasValidtor('require')) {
        <span class="reqIcon" id="require" #require > * </span>
      }
      <span>{{label}}</span>
      @if (hasValidtor('info')) {
        <mat-icon id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info'}"
          class="infoIcon" svgIcon="help.tooltip">
        </mat-icon>
      }
    </div>
  }


  <div (insClickOutside)="dropDownOpened = false" [insCloseListOnScroll]="dropDownOpened" (insListClosedOnScroll)="dropDownOpened = false">
    <div class="selectedRow" #selectedRow [class.filled]="value.length > 0" [class.listOpened]="dropDownOpened" [class.disabled]="disabled"  (click)="toggleDropDown(selectedRow, $event)">
      <div>{{getDisplayValue()}}</div>
      <mat-icon svgIcon={{getIconName()}} class="expandIcon"></mat-icon>
    </div>
    <div #resultsList [class.opened]="dropDownOpened" class="valuesList" [style.width.px]="calculatedWidth" [style.top.px]="calculatedTopForList" >
      <div class="valuesListContent" [style.height.px]="calculatedHeight + 2">
        @if (selectAll) {
          <span>
            <div class="row">
              <mat-checkbox [checked]="isAllSelected()" (change)="onSelectAll($event)">All</mat-checkbox>
            </div>
            <hr style="margin-top: 0; margin-bottom: 0">
          </span>
        }
        @for (option of options; track option) {
          <div class="row">
            <mat-checkbox [checked]="isOptionSelected(option.value)" (change)="changeValue(option, $event)" [disabled]="disabledOptions.indexOf(option.value) !== -1">
            {{option.displayValue}}</mat-checkbox>
          </div>
        }
      </div>
    </div>
  </div>


</div>
